export default __webpack_public_path__ + "static/media/KOD0070-min.4547459f.webp";